import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteScrapFinanceAccountsService } from "@/features/accounts/scrap-finance/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useDeleteScrapFinanceAccountStates } from "@/features/accounts/scrap-finance/hooks/use-delete-accounts-states";
import { useContext } from "react";


export const useDeleteScrapFinanceAccount = () => {
  const {
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useDeleteScrapFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deleteScrapFinanceAccountsService = new DeleteScrapFinanceAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関削除
  const deleteScrapFinanceAccounts = async (
    accountGroupId: string,
    scrapFinanceAccountId: string,
    scrapFinanceId: string
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteScrapFinanceAccountsService.deleteScrapFinanceAccounts({
        account_group_id: accountGroupId,
        scrap_finance_account_id: scrapFinanceAccountId,
        scrap_finance_id: scrapFinanceId,
      });
      // 成功時の処理
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("deleteScrapFinanceAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    isShowErrorDialog,
    setIsShowErrorDialog,
    deleteScrapFinanceAccounts: errorHandledAsync(deleteScrapFinanceAccounts, setError),
  };
};
